module.exports = __webpack_public_path__ + "img/part2-3.77938425.png";